/**
 * Export Issues Status used to track the status of the export in analytics
 */
const ExportIssuesStatus = {
	// Export is initiated but no events have been received yet
	INITIATED: 'INITIATED',
	// Export is in progress
	EXPORTING: 'EXPORTING',
	// Export backend job is completed and download is in progress
	DOWNLOADING: 'DOWNLOADING',
	// Export download  is completed
	COMPLETED: 'COMPLETED',
	// Export has errored
	ERRORED: 'ERRORED',
} as const;

type ExportIssuesStatus = (typeof ExportIssuesStatus)[keyof typeof ExportIssuesStatus];

export const getExportIssuesStatus = ({
	__typename,
	downloadCompleted,
	hasError,
}: {
	__typename?: string;
	downloadCompleted: boolean;
	hasError: boolean;
}): ExportIssuesStatus => {
	if (downloadCompleted) {
		return ExportIssuesStatus.COMPLETED;
	}

	if (
		__typename === 'JiraIssueExportTaskSubmitted' ||
		__typename === 'JiraIssueExportTaskProgress'
	) {
		return ExportIssuesStatus.EXPORTING;
	}

	if (__typename === 'JiraIssueExportTaskCompleted') {
		return ExportIssuesStatus.DOWNLOADING;
	}

	if (__typename === 'JiraIssueExportTaskTerminated' || hasError) {
		return ExportIssuesStatus.ERRORED;
	}

	return ExportIssuesStatus.INITIATED;
};
